import React from 'react';

export const BannerSection = () => {
	return (
		<div>BannerSection</div>
	);
};
